import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();

const baseURL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:3000';

// Download reference file to show in Review modal and save in storage
export const getReferenceFile = async (evalId, taskId, suppressToast = false, filename = null) => {
   try {
    const baseURL = axios.defaults.baseURL || 'http://localhost:3000';
      const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      };

      let url = `${baseURL}/api/eval-runs/${evalId}/download-reference-file/${taskId}`;
      if (filename) {
          url += `?filename=${encodeURIComponent(filename)}`;
      }

      const response = await fetch(url, {
          method: 'GET',
          headers
      });

      if (!response.ok) {
          const error = await response.json().catch(() => ({ message: 'Unknown error' }));
          throw new Error(error.message || 'Download failed');
      }
      return response.blob();
   } catch (error) {
      logApiError(error, 'GET', `${baseURL}/api/eval-runs/${evalId}/download-reference-file/${taskId}`);
      if (!suppressToast) {
          addToast('Error fetching reference file', 'error');
      }
      return false;
   }
};
